// import Slider from "react-slick";
import OldBoss from "./OldBoss";
import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { useSelector } from "react-redux";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function SimpleSlider({ oldBoss , bosses }) {

  const direction = useSelector(({ theme }) => theme.direction);


  // const settings = {
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   // centerMode: true,
  //   // centerPadding: "60px",
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   initialSlide: 2,
  //   // autoplay: true,
  //   // pauseOnHover: false,
  //   speed: 500,
  //   autoplaySpeed: 4000,
  //   cssEase: "linear",
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 4,
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 3,
  //       }
  //     },
  //     {
  //       breakpoint: 550,
  //       settings: {
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 400,
  //       settings: {
  //         slidesToShow: 1,
  //       }
  //     }
  //   ]
  // };


  const options = {
    loop: false,
    autoplay: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    // center: true,
    // margin: 30,
    nav: true,
    dots: false,
    responsiveClass: true,
    smartSpeed: 500,
    dir: 'ltr',
    responsive: {
      0: {
        items: 1,
      },
      550: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      }
    }
  }







  return (
    <div className={`boss-history ${direction === 'rtl' ? 'dir-r' : 'dir-l'}`}>
      {bosses && Object.keys(bosses).length > 5 ?
        // <Slider {...settings}>
        //     {bosses.filter(el => el.isCurrent === false).map(({name , imageUrl , startYear , endYear , capmasHeadTranslations} , i) => (
        //         <OldBoss key={i} personalName={name} personalImg={imageUrl !== null && imageUrl !== undefined ? `${API_BASE_URL}/${imageUrl}` : oldBoss[i]?.personalImg !== null && oldBoss[i]?.personalImg !== undefined ? oldBoss[i]?.personalImg : oldBoss[1]?.personalImg } date={`${startYear} - ${endYear}`} translation={capmasHeadTranslations} cond={true} />
        //     ))}
        // </Slider>
        <OwlCarousel className='owl-theme position-relative' {...options}>
          {bosses.filter(el => el.isCurrent === false).map(({name , imageUrl , startYear , endYear , capmasHeadTranslations} , i) => (
              <OldBoss
                key={i}
                personalName={name}
                personalImg={imageUrl !== null && imageUrl !== undefined
                  ? `${API_BASE_URL}/${imageUrl}`
                  : oldBoss[i]?.personalImg !== null && oldBoss[i]?.personalImg !== undefined 
                    ? oldBoss[i]?.personalImg 
                    : oldBoss[1]?.personalImg
                }
                date={`${startYear} - ${endYear}`}
                translation={capmasHeadTranslations}
                cond={true}
              />
          ))}
        </OwlCarousel>
        :
        <div className="row gx-0 gx-md-3 gy-3 gy-xl-0 d-flex justify-content-start align-items-center">
          {bosses && Object.keys(bosses).length > 0 ?
              bosses.filter(el => el.isCurrent === false).map(({name , imageUrl , startYear , endYear , capmasHeadTranslations} , i) => (
                  <OldBoss
                    key={i}
                    personalName={name}
                    personalImg={imageUrl !== null && imageUrl !== undefined
                      ? `${API_BASE_URL}/${imageUrl}`
                      : oldBoss[i]?.personalImg !== null && oldBoss[i]?.personalImg !== undefined
                        ? oldBoss[i]?.personalImg
                        : oldBoss[1]?.personalImg
                    }
                    date={`${startYear} - ${endYear}`}
                    translation={capmasHeadTranslations}
                    cond={false}
                  />
              ))
            :
            <DataNotFound />
          }
        </div>
      }
    </div>
  );
}